import { Icons } from "../../../../../../shared/icons/icons";

export const clinicContentByMode = {
  all: {
    eyebrow: "Seu espaço",
    title: (
      <>
        Um espaço pensado para o seu momento de <em>autocuidado</em>
      </>
    ),
    description:
      "Cada detalhe foi planejado para que você se sinta confortável, segura e acolhida durante toda a sua experiência.",
    descriptionStrong: "confortável, segura e acolhida",
    button: "Ver o espaço",
    secondaryButton: "Agendar atendimento",
    noteTitle: "Mais que um espaço, um lugar",
    noteAccent: "feito para você.",
    noteText: "Seu conforto é parte essencial da sua transformação.",
  },

  aesthetics: {
    eyebrow: "Seu espaço",
    title: (
      <>
        Um ambiente pensado para sua experiência de <em>beleza</em>
      </>
    ),
    description:
      "Cada detalhe foi pensado para tornar seus procedimentos estéticos mais confortáveis, seguros e acolhedores.",
    descriptionStrong: "procedimentos estéticos",
    button: "Ver o espaço",
    secondaryButton: "Agendar avaliação",
    noteTitle: "Mais que uma clínica, um lugar",
    noteAccent: "feito para realçar você.",
    noteText: "Seu conforto também faz parte da sua experiência estética.",
  },

  nutrition: {
    eyebrow: "Seu espaço",
    title: (
      <>
        Um ambiente tranquilo para cuidar da sua <em>saúde</em>
      </>
    ),
    description:
      "Um espaço acolhedor para conversar, planejar e construir uma rotina alimentar com mais leveza, clareza e segurança.",
    descriptionStrong: "rotina alimentar",
    button: "Conhecer o espaço",
    secondaryButton: "Agendar consulta",
    noteTitle: "Mais que um consultório, um lugar",
    noteAccent: "feito para acolher você.",
    noteText: "Seu conforto ajuda a tornar sua jornada nutricional mais leve.",
  },
};

export const clinicGallery = {
  main: {
    id: "clinic-main",
    src: "/assets/images/homepage/clinic/clinic-main.png",
    alt: "Sala principal da clínica Dionara Krause",
    fallback: "Foto principal do espaço",
  },

  items: [
    {
      id: "clinic-01",
      src: "/assets/images/homepage/clinic/clinic-01.png",
      alt: "Ambiente de atendimento da clínica",
      fallback: "Foto 1",
    },
    {
      id: "clinic-02",
      src: "/assets/images/homepage/clinic/clinic-02.png",
      alt: "Sala de procedimentos da clínica",
      fallback: "Foto 2",
    },
  ],
};